const doc = [({"en":({"js":({"admin":({"photos":({"canvas":({"the_photo_was_deleted":"The photo was deleted."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;